export default {"src":"/_next/static/media/Emergency Neuro Care.77211253.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};